var render, staticRenderFns
import script from "./Sheet.vue?vue&type=script&lang=ts&"
export * from "./Sheet.vue?vue&type=script&lang=ts&"
import style0 from "./Sheet.vue?vue&type=style&index=0&id=6ff8edd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports